export const educationData = [
    {
        id: 1,
        institution: 'Jawahar Navodaya Vidyalaya',
        course: 'Secondary Education (CBSE)',
        startYear: '2014',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Jawahar Navodaya Vidyalaya',
        course: 'Higher Secondary Education (CBSE)',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'National Institute of Technology, Manipur',
        course: 'Bachelor of Technology in CSE',
        startYear: '2022',
        endYear: 'Present'
    },
]